// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__L84Hw","selects":"Documents_selects__2owZ4"};